module.exports = __webpack_public_path__ + "static/media/Alba soffa 3-sits 180_2 tyg Neve Cream 5 detalj 2024 1 fyrkant.afab4bff.jpg";